import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CircularProgress from '@mui/material/CircularProgress';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import { apiService } from '../../api/axiosClient';
import Page from '../../components/Page';
import { FileUploaderSingle } from '../../components/upload';
import DropzoneWrapper from '../../styles/react-dropzone';

const FollowUS = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [item, setItem] = useState('');
    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState([]);
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm()

    useEffect(() => {
        const fetchData = async () => {
            const response = await apiService.get(`/followus/${params.id}`)
            const payload = response.data;
            setItem(payload.data)
        }

        fetchData().catch(e => console.error(e));
    }, [params.id]);

    useEffect(() => {
        const defaultValues = {
            title: item?.title,
            subject: item?.subject,
            url: item?.url,
            showorder: item?.showorder
        }
        reset(defaultValues);
        setFiles(item.icon ? [item.icon] : []);
    }, [reset, item]);

    const goBack = () => {
        navigate(-1)
    }

    const onSubmit = async (data, e) => {
        setLoading(true)

        const [file] = files;

        const formData = new FormData();
        formData.append('title', data.title);
        formData.append('subject', data.subject);
        formData.append('url', data.url);
        formData.append('expose', 1);
        formData.append('showorder', data.showorder);
        formData.append('file', file);

        await apiService.putFormData(`/followus/${item.id}`, formData)
        .then(response => {
            toast.success('업데이트 되었습니다.')
            goBack()
        }).catch(error => {
            // 에러는 이제 axiosClient의 interceptor에서 자동으로 처리됩니다
            console.error('API Error:', error);
        }).finally(() => {
            setLoading(false)
        });
    }

    return (
        <Page title="FollowUS">
            <Card>
                <form onSubmit={handleSubmit(onSubmit)} id="followusform">
                    <CardContent sx={{ pt: 8 }}>
                        <Box sx={{ mb: 9, textAlign: 'center' }}>
                            <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                                FollowUS
                            </Typography>
                        </Box>

                        <Grid container spacing={6}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                <Controller
                                    name='title'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                    <TextField
                                        value={value}
                                        label='제목'
                                        id='title'
                                        onChange={onChange}
                                        placeholder='제목을 입력해주세요'
                                        error={Boolean(errors.title)}
                                        aria-describedby='validation-async-title'
                                        variant="standard"
                                    />
                                    )}
                                />
                                {errors.title && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-title'>
                                    필수
                                    </FormHelperText>
                                )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                <Controller
                                    name='subject'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                    <TextField
                                        value={value || ''}
                                        label='내용'
                                        rows={2}
                                        multiline
                                        id='subject'
                                        onChange={onChange}
                                        placeholder='내용을 입력해주세요'
                                        error={Boolean(errors.subject)}
                                        aria-describedby='validation-async-subject'
                                    />
                                    )}
                                />
                                {errors.subject && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-subject'>
                                    필수
                                    </FormHelperText>
                                )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                <Controller
                                    name='url'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                    <TextField
                                        value={value}
                                        label='URL'
                                        id='url'
                                        onChange={onChange}
                                        placeholder='URL 링크를 입력해주세요'
                                        error={Boolean(errors.url)}
                                        aria-describedby='validation-async-url'
                                        variant="standard"
                                    />
                                    )}
                                />
                                {errors.url && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-url'>
                                    필수
                                    </FormHelperText>
                                )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                <Controller
                                    name='showorder'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                    <TextField
                                        value={value}
                                        label='순서'
                                        id='showorder'
                                        onChange={onChange}
                                        placeholder='순서를 입력해주세요'
                                        error={Boolean(errors.showorder)}
                                        aria-describedby='validation-async-showorder'
                                        variant="standard"
                                    />
                                    )}
                                />
                                {errors.showorder && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-showorder'>
                                    필수
                                    </FormHelperText>
                                )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <DropzoneWrapper>
                                    <FileUploaderSingle files={files} setFiles={setFiles} update={true} />
                                </DropzoneWrapper>
                            </Grid>
                        </Grid>
                    </CardContent>
                </form>

                <CardActions className='card-action'>
                    <Button type="submit" form="followusform" variant='contained'>
                        {loading ? (
                            <CircularProgress
                                sx={{
                                    color: 'common.white',
                                    width: '20px !important',
                                    height: '20px !important',
                                    mr: theme => theme.spacing(2)
                                }}
                            />
                        ) : null}
                        수정
                    </Button>
                    <Button variant='outlined' color='secondary' onClick={goBack}>
                        취소
                    </Button>
                </CardActions>
            </Card>
        </Page>
    )
}

export default FollowUS